import {
    ADD_PRODUCT_DATA_REQUEST,
    ADD_PRODUCT_DATA_SUCCESS,
    ADD_PRODUCT_DATA_FAILED,
    CLEAR_ADD_PRODUCT
} from '../../actions/product/add-furniture-product-data'

const initialState = {
    product: null,
    error: null,
    requesting: false,
    completed: false,
}

export const furnitureNewProduct = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PRODUCT_DATA_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                error: null,
            })
        case ADD_PRODUCT_DATA_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload,
                requesting: false,
                error: null,
                completed: true
            })
        case ADD_PRODUCT_DATA_FAILED:
            return Object.assign({}, state, {
                requesting: false,
                error: action.error
            })
        case CLEAR_ADD_PRODUCT:
            return initialState
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/product/furniture-new-product.js